import React, { useEffect } from 'react';
import { Container, Paper, Typography, Box, Button } from '@mui/material';
import MerchantDashboardContent from './MerchantDashboardContent';
import DynamicMerchantTabs from '../Layout/DynamicMerchantTabs';
import { useMerchantAuth } from '../../../contexts/MerchantAuthContext';
import { Add } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import useRouteMeta from '../../../hooks/useRouteMeta';
const MerchantDashboard = () => {
  const { merchant, refreshProfile } = useMerchantAuth();
  const navigate = useNavigate();
  useRouteMeta();
  // Refresh merchant profile (including credits) when component mounts
  useEffect(() => {
    const loadProfile = async () => {
      try {
        await refreshProfile();
      } catch (error) {
        console.error('Failed to refresh profile on dashboard load:', error);
      }
    };
    
    loadProfile();
  }, []); // Remove refreshProfile from dependency array to prevent infinite loop

  return (
    <>
      <DynamicMerchantTabs />
      <Container maxWidth={false} disableGutters>
        <MerchantDashboardContent />
      </Container>
    </>
  );
};

export default MerchantDashboard; 